import { useDispatch } from "react-redux";
import { encounterDocs } from "./encounter-scanned-docs";
import { setEncounterDocs } from "../../../../entities/patient-stats/encounters/encounter-docs.slice";

export const useGetEncounterScannedDocs = () => {
  const dispatch = useDispatch();

  const getEncounterDocsById = async (encounterID: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = encounterDocs.filter(
          (e) => String(e.encounterId) === encounterID,
        );
        resolve(filtered[0]);
      }, 400);
    }); // имитация API

    dispatch(setEncounterDocs(res)); // сохраняем в сторе
  };

  return {
    getEncounterDocsById,
  };
};
